module.exports = __webpack_public_path__ + "static/media/Heizungsbau.45aad418.jpg";